export default {
  POST_TOKEN: {
    url: '/authentications/recaptcha',
    method: 'POST',
    isPublic: false
  },
  POST_FORGOT_PASSWORD: {
    url: '/authentications/auth/forgotPassword',
    method: 'POST',
    isPublic: true
  },
  REQUEST_FORGOT_PASSWORD_OTP: {
    url: '/authentications/auth/forgotPassword/request',
    method: 'POST',
    isPublic: true
  },
  VERIFY_FORGOT_PASSWORD_OTP: {
    url: '/authentications/auth/forgotPassword/verify',
    method: 'POST',
    isPublic: true
  },
  RESET_FORGOT_PASSWORD: {
    url: '/authentications/auth/forgotPassword/reset',
    method: 'POST',
    isPublic: true
  }
}
